import { compose } from 'redux'
import { connect } from 'react-redux'
import hasUpdateProgram from '../../hoc/hasUpdateProgram'
import toJS from '../../hoc/toJS'
import config from '../../config.json'
import PageWeischerPage from '../../components/PageWeischer/PageWeischerPage'
import { WEISCHER } from '../../constants/itemTypes'
import { CLI_CINEMA_CLIENT_ID, PROGRAM_CINEMAS, PROGRAM_WEISCHERAD_ITEMS } from '../../constants/state'
import getData from '../../functions/getData'
import { weischerAdUpdateItem } from '../../actions'

const mapDispatchToProps = (dispatch, ownProps) => ({
    addItem: (type) => {
        const routes = config.routes
        ownProps.history.push(`${routes.weischer.path}/${WEISCHER}/${type}/addItem/form`)
    },
    onUpdateItem: (itemId, itemData) => {
        dispatch(weischerAdUpdateItem(itemId, itemData))
    }
})

const mapStateToProps = state => ({
    items: getData(state, [PROGRAM_WEISCHERAD_ITEMS]),
    state: state,
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    weischerConfig: state.getIn(['wpServerData', 'data', 'data', 'advertisement_config'])
})

const PageWeischer = ({state, programStatus, programError, items, onUpdateItem, addItem, onUpdateProgram, cliCinemas, clientCinemaId, weischerConfig, goBackPath}) => {
   return <PageWeischerPage
           weischerConfig={weischerConfig} 
           addItem={addItem} 
           items={items} 
           programStatus={programStatus}
           programError={programError}
           onUpdateItem={onUpdateItem}
           onUpdateProgram={onUpdateProgram}
           cliCinemas={cliCinemas}
           clientCinemaId={clientCinemaId}
           cliData={state.cliData}
           closePagePath={goBackPath}
       />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PageWeischer)

